export function QuizForm() {
    document.addEventListener('DOMContentLoaded', () => {
        const forms = document.querySelectorAll('[data-quiz-form]');
        if (!forms.length) return;

        forms.forEach((form) => {
            const error = form.querySelector('[data-quiz-form-error]');
            const radios = form.querySelectorAll('input[type="radio"][name="answer"]');
            if (!error || !radios.length) return;

            form.addEventListener('submit', (event) => {
                const picked = Array.from(radios).some((radio) => radio.checked);
                if (picked) return;

                event.preventDefault();
                error.hidden = false;
                form.classList.add('is-invalid');
                radios[0].focus({ preventScroll: true });
            });

            radios.forEach((radio) => {
                radio.addEventListener('change', () => {
                    error.hidden = true;
                    form.classList.remove('is-invalid');
                });
            });
        });
    });
}
